<template>
    <div>
        数据维度:<Select v-model="rowOrColumn" style="width:50px" @on-change="changed" size='small'>
            <Option value="row">行</Option>
            <Option value="column">列</Option>
        </Select>
        <div v-for="(item, index) in indexs" :key="index">
            系列{{index+1}}: 第
            <InputNumber v-model="indexs[index]" style="width:40px" @on-change="changed" size='small'></InputNumber>
            {{rowOrColumn==='column'?'列':'行'}}
            <span @click="removeSerie(index)">删除</span>    
        </div>
        <span @click="addSerie">添加</span>
    </div>
</template>
<script>
export default {
    props:["value", "data"],
    data() {
        return {
            rowOrColumn:"row",
            indexs:[0]
        }
    },
    watch: {
        value:{
            handler(v){
                if(v){
                    if(this.value.rowOrColumn!==undefined){
                        this.rowOrColumn = this.value.rowOrColumn;
                    }
                    if(this.value.indexs!==undefined){
                        this.indexs = this.value.indexs;
                    }
                }
            },
            immediate:true
        }
    },
    methods: {
        changed(){
            this.$emit("input", {
                rowOrColumn:this.rowOrColumn, 
                indexs:this.indexs
            })
            this.$emit("save");
        },

        addSerie(){
            this.indexs.push(0);
            this.changed();
        },

        removeSerie(index){
            this.indexs.splice(index,1);
            this.indexs = [...this.indexs];
            this.changed();
        }
    },
}
</script>